// Same-day shipping countdown for Europe/Copenhagen (Mon–Fri, 15:00 cutoff)
(function(){
  const NS = (window.CustomScripts = window.CustomScripts || {});
  const INIT_FLAG = 'shippingCutoffBound';

  function two(n){ return String(n).padStart(2,'0'); }

  function initShippingCutoff(root){
    const scope = root || document;
    const blocks = scope.querySelectorAll('.shipping-cutoff');
    if (!blocks.length) return;

    blocks.forEach(block => {
      if (block.dataset[INIT_FLAG] === '1') return;
      block.dataset[INIT_FLAG] = '1';

      const tz = block.dataset.timezone || 'Europe/Copenhagen';
      const cutoffHour = parseInt(block.dataset.cutoffHour || '15', 10);
      const workdays = (block.dataset.workdays || '1,2,3,4,5').split(',').map(n => parseInt(n,10));

      const statusEl = block.querySelector('.shipping-cutoff__status');
      const countdownEl = block.querySelector('.shipping-cutoff__countdown');

      function getTZParts(date){
        const fmt = new Intl.DateTimeFormat('en-CA', {
          timeZone: tz,
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit',
          hour12: false, weekday: 'numeric'
        });
        const parts = Object.fromEntries(fmt.formatToParts(date).map(p => [p.type, p.value]));
        return {
          y:+parts.year, m:+parts.month, d:+parts.day,
          H:+parts.hour, M:+parts.minute, S:+parts.second,
          wd: Math.max(1, Math.min(7, parseInt(parts.weekday||'1',10)))
        };
      }

      function makeZonedDate(y,m,d,H=0,M=0,S=0){
        const probe = new Date(Date.UTC(y, m-1, d, H, M, S));
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: tz, hour12: false,
          year:'2-digit', month:'2-digit', day:'2-digit',
          hour:'2-digit', minute:'2-digit', second:'2-digit',
          timeZoneName: 'shortOffset'
        }).formatToParts(probe);
        const tzName = (parts.find(p=>p.type==='timeZoneName')||{value:'GMT+00:00'}).value; // "GMT+02:00"
        const offset = tzName.replace('GMT','');
        const iso = `${y}-${two(m)}-${two(d)}T${two(H)}:${two(M)}:${two(S)}${offset}`;
        return new Date(iso);
      }

      function nextBusinessCutoff(now){
        const pNow = getTZParts(now);
        if (workdays.includes(pNow.wd) && pNow.H < cutoffHour){
          return makeZonedDate(pNow.y, pNow.m, pNow.d, cutoffHour, 0, 0);
        }
        for (let i=1;i<=7;i++){
          const t = new Date(now.getTime() + i*86400000);
          const p = getTZParts(t);
          if (workdays.includes(p.wd)){
            return makeZonedDate(p.y, p.m, p.d, cutoffHour, 0, 0);
          }
        }
        return makeZonedDate(pNow.y, pNow.m, pNow.d, cutoffHour, 0, 0);
      }

      function formatDHMS(ms){
        const total = Math.max(0, Math.floor(ms/1000));
        const h = Math.floor(total/3600);
        const m = Math.floor((total%3600)/60);
        const s = total%60;
        return `${two(h)}:${two(m)}:${two(s)}`;
      }

      function tick(){
        const now = new Date();
        const parts = getTZParts(now);
        const target = nextBusinessCutoff(now);
        const delta = target - now;
        const isWorkday = workdays.includes(parts.wd);
        const beforeCutoff = isWorkday && parts.H < cutoffHour;

        if (beforeCutoff) {
          statusEl.textContent = 'Order within';
        } else {
          statusEl.textContent = 'Order now — ships next business day';
        }
        countdownEl.textContent = formatDHMS(delta);
        countdownEl.style.display = '';
      }

      tick();
      const intervalId = setInterval(tick, 1000);

      // Clean up if block is removed (Prestige sometimes re-renders parts of the product section)
      const obs = new MutationObserver(() => {
        if (!document.body.contains(block)) {
          clearInterval(intervalId);
          obs.disconnect();
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    });
  }

  // Expose for re-use (quick view, modals, section reloads)
  NS.initShippingCutoff = initShippingCutoff;

  // Init on first load
  document.addEventListener('DOMContentLoaded', function(){ initShippingCutoff(document); });

  // Init when Shopify sections are (re)loaded in the editor or by the theme
  document.addEventListener('shopify:section:load', function(e){ initShippingCutoff(e.target); });
  document.addEventListener('shopify:section:select', function(e){ initShippingCutoff(e.target); });
})();
